import { getValueFromCookie } from '@/utils/cookie';
import Constants from '@/constants/const';
import { EMAIL_VALID_REG, PHONE_VALID_REG, STRICT_EMAIL_VALID_REG } from '@/constants/reg_rules';

export const getLoginState = (ctx?): boolean => {
  return !!(getValueFromCookie(Constants.IS_LOGIN, ctx) === '1');
};

export const getLang = (ctx?): string => {
  return getValueFromCookie(Constants.LANGUAGE, ctx);
};

/**
 * 判断是否是中文、中文繁体
 * @param lang 现在的语言
 */
export const isLikeChinese = lang => {
  let likeChinese = [Constants.LANGUAGE_ZH, Constants.LANGUAGE_ZHT, Constants.LANGUAGE_ZHT_ALIAS];
  if (likeChinese.includes(lang)) {
    return true;
  }
  return false;
};

export const getValidUserIdWhateverIsLogin = (ctx?): string => {
  return getValueFromCookie(Constants.USER_ID, ctx) || getValueFromCookie(Constants.TEMP_USER_ID, ctx);
};

/**
 * 把zh-Hant 转化为zht
 * 把zh-Hans 转化为zh
 * @param lan
 * @returns
 */
export const setLanguageToFrontend = (lan = '') => {
  if (lan === Constants.LANGUAGE_ZHT_ALIAS) {
    return Constants.LANGUAGE_CHINESE_T;
  }
  if (lan === Constants.LANGUAGE_ZH_ALIAS) {
    return Constants.LANGUAGE_CHINESE;
  }
  return lan;
};

export const getbCookie = (ctx?) => {
  return getValueFromCookie(Constants.B_COOKIE, ctx) || '';
};

// 邮件格式校验松散
export const checkValidityEmail = (val: string) => {
  return EMAIL_VALID_REG.test(val);
};

// 邮件格式校验严格
export const checkValidityEmailStrict = (val: string) => {
  return STRICT_EMAIL_VALID_REG.test(val);
};

// 电话格式校验
export const checkValidityPhone = (val: string) => {
  return PHONE_VALID_REG.test(val);
};
